export default {
  root: {
    color: '#66788A'
  }
};
